import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
import EcoIconArr from 'eco-design-micro/icons/eco-icon-arrow';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { AnimatedGrid } from '../../us/StatusA/Components/AnimatedSection';
import CommonTitle from '../../us/StatusA/Components/CommonTitle';
import styles from './index.module.scss';

interface CutCostsConfig {
    title: string;
    className?: string;
    list: {
        title: string;
        desc: React.ReactNode;
        pc: string;
    };
}
interface CutCostsProps {
    config?: Partial<CutCostsConfig>;
}
const CutCosts: React.FC<CutCostsProps> = (props) => {
    const { t } = useLang('CutCosts');
    const { locale = 'us' } = useRouter();
    const [selectIndex, setSelectIndex] = useState(0);

    // 点击切换
    const itemHandle = (item, index) => {
        if (index == selectIndex) {
            return false;
        }
        setSelectIndex(index);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: item.title,
            __btn_id1: `${styles.CutCosts} .tab-${index + 1}`,
            __btn_id2: item.title,
            __btn_type: 'common',
        });
    };

    const imgArray = {
        us: [
            'https://websiteoss.ecoflow.com/figma-uploads/1757493367816-wrlszr-compressed-AI%20Mode.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1757493380743-ha729c-compressed-SELF-POWERED.png',
        ],
        eu: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761648361326-7klif1-compressed-AI%20Mode.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761648373243-ris1op-compressed-SELF-POWERED.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761648220109-71lwzu-compressed-AI%20Mode.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761648264502-anboio-compressed-SELF-POWERED.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761648280132-00s78c-compressed-AI%20Mode.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761648293240-wqovmt-compressed-SELF-POWERED.png',
        ],
        it: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761648305750-dlfxnb-compressed-AI%20Mode.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761648319056-t2naww-compressed-SELF-POWERED.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/figma-uploads/1761648335074-3lb3i5-compressed-AI%20Mode.png',
            'https://websiteoss.ecoflow.com/figma-uploads/1761648345488-rvrew5-compressed-SELF-POWERED.png',
        ],
    };

    // 获取当前语言的图片，如果不存在则使用英文版
    const currentImages = imgArray[locale] || imgArray.us;

    const defaultConfig = {
        title: t('title'),
        desc: t('desc'),
        list: [
            {
                pc: currentImages[0],
                title: t('tab1_title'),
                desc: t.rich('tab1_desc', {
                    sup: (text: string) => <sup>{text}</sup>,
                }),
            },
            {
                pc: currentImages[1],
                title: t('tab2_title'),
                desc: t('tab2_desc'),
            },
        ],
    };
    const config = { ...defaultConfig, ...props.config };

    const list = (props.config?.list || defaultConfig.list).map((item: any, index: number) => ({
        ...defaultConfig.list[index],
        ...item,
    }));

    return (
        <div className={`page-cutCosts ${styles.CutCosts} GtmModuleData-section`} data-section-id="d3m-cut-costs">
            {/* <AnimatedSection variant="fadeInUp" options={{ delay: 400 }}>
                <EcoSectionCommon className={`section-content enter`} title={config.title} desc={config.desc} />
            </AnimatedSection> */}
            <CommonTitle title={config.title} desc={config.desc} />
            {/* <EcoFaqWithImg className="section-card-faq" items={list} /> */}
            <AnimatedGrid variant="rotateIn" options={{ delay: 200, stagger: 0.15, threshold: 0.2 }} className="eco-content cutCosts-container">
                <div className="cutCosts-img">
                    <EcoImgVideo key={`img-${selectIndex}`} pc={list[selectIndex].pc} isOpenLazy={true} />
                </div>
                <div className="list-container">
                    {list.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`item item-${index + 1} GtmModule-btn-common${selectIndex === index ? ' item-active' : ''}`}
                                data-btn-id={item.title}
                                onClick={() => {
                                    itemHandle(item, index);
                                }}
                            >
                                <div className="item-content">
                                    <div className="item-title">
                                        {item.title}
                                        <EcoIconArr />
                                    </div>
                                    <div className="item-msg">
                                        <div className="item-desc">{item.desc}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </AnimatedGrid>
        </div>
    );
};

export default CutCosts;
